import dynamicIconImports from "lucide-react/dynamicIconImports";

/** The installed Lucide catalog is the allowlist for both saving and rendering. */
type IconName = keyof typeof dynamicIconImports;
export const optionIconNames = Object.keys(dynamicIconImports) as [
  IconName,
  ...IconName[],
];

/** Human-readable labels derived directly from the library's icon names. */
export function optionIconLabel(icon: IconName): string {
  return icon.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
